module.exports = __webpack_public_path__ + "img/logo_text.45f0bb0e.svg";